import { AlertTriangle, X } from "lucide-react";

import { cn } from "@/lib/utils";

interface ErrorAlertProps {
  message: string;
  onDismiss: () => void;
  className?: string;
}

export function ErrorAlert({ message, onDismiss, className }: ErrorAlertProps) {
  return (
    <div
      role="alert"
      className={cn(
        "border-outcome-blocked/30 bg-outcome-blocked-tint flex items-start gap-3 rounded-lg border px-4 py-3",
        className,
      )}
    >
      <AlertTriangle className="text-outcome-blocked mt-0.5 h-4 w-4 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-outcome-blocked text-sm font-semibold">Request failed</p>
        <p className="text-foreground/80 mt-0.5 text-sm break-words">{message}</p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss error"
        className="text-outcome-blocked/70 hover:text-outcome-blocked rounded p-1"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
